import { getPageName } from "../../page/selectors";
import { CATEGORY_PAGE, SEARCH_PAGE } from "../../page/constants";
import { getFloor } from "../../config/selectors";
import { getCategoryGender } from "../../category/selectors";
import { getPaginationData } from "../../search/selectors";
import { FLOOR_DEFAULT } from "../../config/constants";

const pageNameStateValidatorMap = {
  [CATEGORY_PAGE]: state => getCategoryGender(state),
  [SEARCH_PAGE]: state => getFloor(state) !== FLOOR_DEFAULT
};

const isRendered = state =>
  !!state.adverts &&
  !!pageNameStateValidatorMap[getPageName(state)]?.(state) &&
  [1, null].includes(getPaginationData(state).page.initial);

export default isRendered;
